import React, { Component, useState, useEffect } from 'react';
import { Col , Row , Select, Empty , Button, message, Card, Statistic, Spin, Icon , DatePicker} from 'antd';
import axios from 'axios'
import TopNavBar from '../components/TopNavBar';
import TopBrandBar from '../components/TopBrandBar';
import RowCard from '../components/RowCard';
import Search from '../components/Search';
import keys from '../../../keys';
import { fetchReports } from '../../../redux/reports/actions/actionCreators';
import { connect } from 'react-redux';
import { updateReports, selectReport } from '../../../redux/reports/actions/actions';
import PieChart from '../components/DataVizualizations/PieChart';
import CustomLineChart from '../components/DataVizualizations/LineChart';
import moment from 'moment'

const {Option} =  Select

const date = new Date()

const styles = {
    cardStyles :{
        boxShadow : "5px 5px 10px lightgray",
        color : "#fff",
        backgroundColor: "#1890ff",
        border : "None",
       
    }
}

class Dashboard extends Component {

    state = {
        from_date :new Date(date.getFullYear() , date.getMonth() , 2).toISOString().slice(0,10),
        to_date :  new Date().toISOString().slice(0,10),
        loading : false,
        sales_by_route : [],
        collection_by_route : [],
        time_series : []
    }

    componentDidMount = ()=>{this.setState( {loading : true},()=> {
        this.loadDashboardData(this.state.from_date , this.state.to_date)
    } )}

    loadDashboardData = (from_date , to_date)=> {
        axios.get('/api/analytics/dashboard/',{params:{from_date:from_date , to_date : to_date}})
        .then( response => {
            this.setState(
                {loading : false,
                ...response.data
                }
            )
        })
        .catch(
            er => {
                console.error(er)
                message.error("Loading dashboard failed!")
            }
        )
    }



    navigate = (link) =>{
        this.props.history.push(link) 
    }

    onDateRangeChange = (dates,dateStrings) => {
        this.setState({
            from_date : dateStrings[0],
            to_date : dateStrings[1],
            loading : true

        }
        ,
        () => {

            this.loadDashboardData(this.state.from_date , this.state.to_date)
        }
        )

    }
   
    render() { 
        return ( 
            <>
            <TopNavBar navigate={this.navigate} title={"Dashboard"}/>
            <Spin 
                tip="Loading..." 
                indicator={<Icon  type="loading-3-quarters" spin />} 
                spinning={this.state.loading}
                >
            <Row>
                <Col span={24} >    
                <Row  style={{margin:20}}>
                    <Col  span={8} > 
                        Date Range: <DatePicker.RangePicker allowClear={false} value={[moment(this.state.from_date),moment(this.state.to_date)]}  onChange={this.onDateRangeChange}></DatePicker.RangePicker>
                    </Col>
                   
                </Row>
                <Row style={{margin:"20px" }}>
                    <Col span={8}> 
                        <Row>
                            <Col span={12} style={{padding:"5px"}} >      
                                <Card style={styles.cardStyles}>
                                    <Statistic 
                                        valueStyle={{color:"#fff"}} 
                                        style={{color:"#fff"}} 
                                        title={<div style={{color:"#fff"}}>Total Sales</div>}  
                                        value={"Rs. "+this.state.total_sales}>
                                    </Statistic>
                                </Card>                         
                            </Col>
                            <Col span={12} style={{padding:"5px"}} >
                                <Card style={styles.cardStyles}>
                                    <Statistic  
                                        valueStyle={{color:"#fff"}} 
                                        title={<div style={{color:"#fff"}}>Total Collection</div>} 
                                        value={"Rs. " +this.state.total_collection}>
                                    </Statistic>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col  span={12} style={{padding:"5px"}}>      
                                <Card  style={{...styles.cardStyles, backgroundColor:"#e8093a"
                                }
                                    }>
                                    <Statistic  
                                        valueStyle={{color:"#fff"}} 
                                        title={<div style={{color:"#fff"}}>Total Overdue</div>} 
                                        value = {"Rs. " + this.state.total_overdue}>

                                        </Statistic>
                                </Card>                         
                            </Col>
                            <Col span={12} style={{padding:"5px"}} >
                                <Card style={{...styles.cardStyles, backgroundColor:"#00d957"}}>
                                    <Statistic 
                                        valueStyle={{color:"#fff"}} 
                                        title={<div style={{color:"#fff"}}>No of Active Cards</div>} 
                                       value = {this.state.number_of_active_cards}></Statistic>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} style={{padding:"5px"}}>
                                <Card title="Sales by route" style={{alignContent:"center", textAlign:"center"}}>
                                    <PieChart data={this.state.sales_by_route.map(value => ({"name":value.Route , "value": value.Amount}))}/>
                                </Card>
                            </Col>
                            <Col span={12} style={{padding:"5px"}}>
                                <Card  title="Collection by route" style={{alignContent:"center", textAlign:"center"}}>
                                    <PieChart data={this.state.collection_by_route.map(value => ({"name":value.Route , "value": value.Amount}))}/>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={16} style={{padding:"5px"}}>
                                <Card title= {<div> <Icon type="LineChartOutlined"/>Sales trend</div>}>
                            <CustomLineChart type="area" 
                            data={this.state.time_series.map(value =>({"Period":value.period , "Sales":value.value}) )}
                            />
                        </Card>
                    </Col>
                </Row>
                </Col>
            </Row>
            </Spin>
            </>
         );
    }
}


const mapStateToProps = state => ({
    categories : state.product.categories,
    reports : state.reports
})

const mapDispatchToProps = dispatch => ({
    fetchReports : (sc , ec) => dispatch(fetchReports(sc,ec)),
    updateReports : (reports) => dispatch(updateReports(reports)),
    selectReport : report => dispatch(selectReport(report))
})
 

export default connect(mapStateToProps,mapDispatchToProps)(Dashboard);